<template>
	<div class="editor">
		<v-row
			ref="text-box"
			no-gutters
			style="border-radius: 5px; border: 1px solid rgba(0, 0, 0, 0.24); padding: 10px; overflow-y: auto;cursor:text"
			@click="focusEditor"
		>
		<v-col cols="12">
			<editor-content style="outline: none;" ref="editorContent" class="editor__content" :editor="editor" @onBlur="edit" />
		</v-col>
		<v-col cols="12">
			<editor-menu-bar :editor="editor" v-slot="{ commands, isActive, focused }">
				<div class="menubar is-hidden" :class="{ 'is-focused': focused }">
					<v-divider class="mb-1"></v-divider>
					<v-row no-gutters>
						<button
							class="menubar__button"
							:class="{ 'is-active': isActive.bold() }"
							@click="commands.bold"
							type="button"
						>
							<v-icon>mdi-format-bold</v-icon>
						</button>

						<button
							class="menubar__button"
							:class="{ 'is-active': isActive.italic() }"
							@click="commands.italic"
							type="button"
						>
							<v-icon>mdi-format-italic</v-icon>
						</button>

						<button
							class="menubar__button"
							:class="{ 'is-active': isActive.strike() }"
							@click="commands.strike"
							type="button"
						>
							<v-icon>mdi-format-strikethrough</v-icon>
						</button>

						<button
							class="menubar__button"
							:class="{ 'is-active': isActive.underline() }"
							@click="commands.underline"
							type="button"
						>
							<v-icon>mdi-format-underline</v-icon>
						</button>

						<button
							class="menubar__button"
							:class="{ 'is-active': isActive.code() }"
							@click="commands.code"
							type="button"
						>
							<v-icon>mdi-code-tags</v-icon>
						</button>

						<button
							class="menubar__button"
							:class="{ 'is-active': isActive.paragraph() }"
							@click="commands.paragraph"
							type="button"
						>
							<v-icon>mdi-format-paragraph</v-icon>
						</button>

						<button
							class="menubar__button"
							:class="{ 'is-active': isActive.heading({ level: 1 }) }"
							@click="commands.heading({ level: 1 })"
							type="button"
						>
							<span style="color:rgba(0, 0, 0, 0.54)">
								<strong>H1</strong>
							</span>
						</button>

						<button
							class="menubar__button"
							:class="{ 'is-active': isActive.heading({ level: 2 }) }"
							@click="commands.heading({ level: 2 })"
							type="button"
						>
							<span style="color:rgba(0, 0, 0, 0.54); margin-left: 5px">
								<strong>H2</strong>
							</span>
						</button>

						<button
							class="menubar__button"
							:class="{ 'is-active': isActive.heading({ level: 3 }) }"
							@click="commands.heading({ level: 3 })"
							type="button"
						>
							<span style="color:rgba(0, 0, 0, 0.54); margin-left: 5px; margin-right: 5px">
								<strong>H3</strong>
							</span>
						</button>

						<button
							class="menubar__button"
							:class="{ 'is-active': isActive.bullet_list() }"
							@click="commands.bullet_list"
							type="button"
						>
							<v-icon>mdi-format-list-bulleted</v-icon>
						</button>

						<button
							class="menubar__button"
							:class="{ 'is-active': isActive.ordered_list() }"
							@click="commands.ordered_list"
							type="button"
						>
							<v-icon>mdi-format-list-numbered</v-icon>
						</button>

						<button
							class="menubar__button"
							:class="{ 'is-active': isActive.blockquote() }"
							@click="commands.blockquote"
							type="button"
						>
							<v-icon>mdi-format-quote-close</v-icon>
						</button>

						<button
							class="menubar__button"
							:class="{ 'is-active': isActive.code_block() }"
							@click="commands.code_block"
							type="button"
						>
							<v-icon>mdi-code-tags</v-icon>
						</button>

						<button class="menubar__button" @click="commands.horizontal_rule" type="button">
							<v-icon>mdi-minus</v-icon>
						</button>

						<button class="menubar__button" @click="commands.undo" type="button">
							<v-icon>mdi-undo</v-icon>
						</button>

						<button class="menubar__button" @click="commands.redo" type="button">
							<v-icon>mdi-redo</v-icon>
						</button>
						<v-spacer></v-spacer>
						<template v-if="category || customTreatment">
						<v-btn depressed small class="ml-2 float-right" @click="importTreatments">
							<translate>Import</translate>
							<v-icon small>mdi-file-import-outline</v-icon>
						</v-btn>
						<v-dialog v-model="showImportTreatments" max-width="40%">
							<v-card>
								<v-card-title class="title primary--text mb-2 secondary">
									<translate>Import Treatment</translate>
								</v-card-title>
								<v-card-text>
									<p
										v-if="treatments.length == 0"
										class="font-weight-thin ml-2"
										v-translate
									>No treatments to import.</p>
									<v-list v-else flat>
										<v-list-item
											:key="treatment.name"
											style="border: 1px solid #e0e0e0; border-radius: 5px"
											v-for="treatment in treatments"
											@click="importTreatment(treatment)"
										>
											<v-list-item-icon class="mr-3">
												<v-icon>mdi-clipboard-text-outline</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>
													<strong>{{treatment.name}}</strong>
												</v-list-item-title>
											</v-list-item-content>
											<v-list-item-action>
												<v-row no-gutters>
													<v-chip text-color="white">
														<span v-if="customTreatment">{{customTreatment.name}}</span>
														<span v-else-if="category === 'nut'" v-translate>Nutrition</span>
														<span v-else-if="category === 'qg'">Qi Gong</span>
														<span v-else-if="category === 'tn'">Tui Na</span>
													</v-chip>
												</v-row>
											</v-list-item-action>
										</v-list-item>
									</v-list>
								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn color="primary darken-1" text @click="showImportTreatments = false">
										<translate>Close</translate>
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>
						</template>
						<template v-if="consent">
							<v-btn depressed small class="ml-2 float-right" @click="importConsents">
								<translate>Import</translate>
								<v-icon small>mdi-file-import-outline</v-icon>
							</v-btn>
							<v-dialog v-model="showImportConsents" max-width="70%">
								<v-card>
									<v-card-title class="title primary--text mb-2 secondary">
										<translate>Import Consent</translate>
									</v-card-title>
									<v-card-text>
										<p
											v-if="consents.length == 0"
											class="font-weight-thin ml-2"
											v-translate
										>No consents to import.</p>
										<v-list v-else flat>
											<v-list-item
												:key="consent.id"
												style="border: 1px solid #e0e0e0; border-radius: 5px"
												v-for="consent in consents"
												@click="importConsent(consent)"
											>
												<v-list-item-icon class="mr-3">
													<v-icon>mdi-clipboard-text-outline</v-icon>
												</v-list-item-icon>
												<v-list-item-content>
													<v-list-item-title>
														<strong>{{consent.title}}</strong>
													</v-list-item-title>
												</v-list-item-content>
												<!-- <v-list-item-action>
													<v-row no-gutters>
														<v-chip text-color="white">
															<translate v-if="category === 'nut'">Nutrition</translate>
															<span v-if="category === 'qg'">Qi Gong</span>
														</v-chip>
													</v-row>
												</v-list-item-action> -->
											</v-list-item>
										</v-list>
									</v-card-text>
									<v-divider></v-divider>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn color="primary darken-1" text @click="showImportConsents = false">
											<translate>Close</translate>
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-dialog>
						</template>
					</v-row>
					<!-- <v-divider class="mt-1"></v-divider> -->
				</div>
			</editor-menu-bar>
		</v-col>
		</v-row>
	</div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import {
	Blockquote,
	CodeBlock,
	HardBreak,
	Heading,
	HorizontalRule,
	OrderedList,
	BulletList,
	ListItem,
	TodoItem,
	TodoList,
	Bold,
	Code,
	Italic,
	Link,
	Strike,
	Underline,
	History,
	Placeholder
} from "tiptap-extensions";
import axios from "axios";

export default {
	name: "RichTextEditor",
	props: {
		text: {
			default: null
		},
		context: {
			default: "appointment"
		},
		category: {},
		customTreatment: {
			default: null
		},
		consent: {
			default: false
		},
		consentType: {
			default: 'terapeutic'
		},
		isMinor: {
			default: false
		}
	},
	data: () => ({
		editor: null,
		showImportTreatments: false,
		showImportConsents: false,
		treatments: [],
		consents: [],
		showMenu: false
	}),
	components: {
		EditorContent,
		EditorMenuBar
	},
	methods: {
		edit(obj) {
			console.log(obj);
			//if(!this.isDescendant(this.$refs['text-box'], obj.event.explicitOriginalTarget)) {
			if (this.context === "appointment") this.$emit("edit", this.editor.getHTML());
			//}
		},
		isDescendant(parent, child) {
			if(parent == child) return true;
			var node = child.parentNode;
			while (node != null) {
					if (node == parent) {
							return true;
					}
					node = node.parentNode;
			}
			return false;
		},
		importTreatments() {
			var params;
			if(this.customTreatment) {
				params = {
					custom: true,
					id: this.customTreatment.id
				}
			} else {
				params = {
					custom: false,
					category: this.category
				}
			}
			axios
				.get("/api/premade_treatments", {
					params: params
				})
				.then(response => {
					console.log(response.data);
					this.treatments = response.data.treatments;
				})
				.catch(error => console.log(error));
			this.showImportTreatments = true;
		},
		importConsents() {
			axios
        .get("/patient-consent/" + this.consentType, {params: {minor: this.isMinor}})
        .then(response => {
          console.log(response.data);
          this.consents = response.data.consents;
        })
        .catch(error => {
          console.log(error)
        });
			this.showImportConsents = true;
		},
		importTreatment(treatment) {
			this.editor.setContent(treatment.text);
			this.editor.focus();
			this.showImportTreatments = false;
		},
		importConsent(consent) {
			this.editor.setContent(consent.text);
			this.editor.focus();
			this.showImportConsents = false;
		},
		focusEditor() {
			console.log("set focus");
			this.editor.focus();
		},
		getHTML() {
			return this.editor.getHTML();
		},
		resetField() {
			this.editor.clearContent();
		},
		setContent(text) {
			this.editor.setContent(text);
		},
		update() {
			console.log(this.text);
			this.setContent(this.text);
		}
	},
	mounted() {
		this.editor = new Editor({
			extensions: [
				new Blockquote(),
				new BulletList(),
				new CodeBlock(),
				new HardBreak(),
				new Heading({ levels: [1, 2, 3] }),
				new HorizontalRule(),
				new ListItem(),
				new OrderedList(),
				new TodoItem(),
				new TodoList(),
				new Link(),
				new Bold(),
				new Code(),
				new Italic(),
				new Strike(),
				new Underline(),
				new History(),
				new Placeholder({
					emptyNodeClass: "is-empty",
					emptyNodeText: this.$gettext("Treatment"),
					showOnlyWhenEditable: true,
					showOnlyCurrent: true
				})
			],
			content: this.text,
			onBlur: this.edit,
			onFocus: this.showMenu
		});
	},
	beforeDestroy() {
		this.editor.destroy();
	}
};
</script>

<style scoped>
>>> .ProseMirror {
  outline: none;
}
</style>

<style scoped lang="scss">
.menubar {
	margin-bottom: 0.5rem;
	transition: visibility 0.2s 0.4s, opacity 0.2s 0.4s;

	&.is-hidden {
		visibility: hidden;
		display: none;
		opacity: 0;
	}

	&.is-focused {
		visibility: visible;
		display: inline;
		opacity: 1;
		transition: visibility 0.2s, opacity 0.2s;
	}

	&__button {
		font-weight: bold;
		display: inline-flex;
		background: transparent;
		border: 0;
		color: #000000;
		padding: 0.2rem 0.2rem;
		margin-right: 0.2rem;
		border-radius: 3px;
		cursor: pointer;

		&:hover {
			background-color: rgba(#000000, 0.05);
		}

		&.is-active {
			background-color: rgba(#000000, 0.1);
		}
	}

	span#{&}__button {
		font-size: 13.3333px;
	}
}
</style>